<template>
    <div class="min-h-screen bg-gray-50 p-4 md:p-8 flex items-center justify-center">
        <div class="back flex items-center space-x-4">
            <button @click="goBack" class="flex items-center text-reader-text hover:text-primary">
                <i class="fa fa-arrow-left mr-2"></i>
                <span class="text-sm">返回</span>
            </button>
        </div>
        <!-- 个人简介卡片 -->
        <div class="w-full max-w-3xl bg-white rounded-2xl shadow-xl overflow-hidden transition-all duration-300 hover:shadow-2xl">
            <!-- 顶部装饰条 -->
            <div class="h-3 bg-gradient-to-r from-blue-500 to-purple-600"></div>

            <!-- 头像和基本信息 -->
            <div class="flex flex-col md:flex-row items-center p-8 md:p-10">
                <!-- 头像 -->
                <div class="relative mb-6 md:mb-0 md:mr-8">
                    <img
                        :src="profile.avatar || 'https://picsum.photos/200/200?random=1'"
                        alt="个人头像"
                        class="w-32 h-32 md:w-40 md:h-40 rounded-full object-cover border-4 border-white shadow-lg"
                    >
                    <div class="absolute -bottom-2 -right-2 bg-green-500 w-6 h-6 rounded-full border-2 border-white flex items-center justify-center">
                        <i class="fa fa-check text-white text-xs"></i>
                    </div>
                </div>

                <!-- 名称和状态 -->
                <div class="text-center md:text-left">
                    <h1 class="text-2xl md:text-3xl font-bold text-gray-800 mb-1">{{ profile.name }}</h1>
                    <p class="text-blue-600 font-medium mb-4">{{ profile.title }}</p>
                    <div class="flex items-center justify-center md:justify-start space-x-4">
                        <div class="flex items-center text-gray-500">
                            <i class="fa fa-calendar-o mr-1"></i>
                            <span>{{ profile.joinDate }}</span>
                        </div>
                        <div class="flex items-center text-gray-500">
                            <i class="fa fa-map-marker mr-1"></i>
                            <span>{{ profile.location }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 分隔线 -->
            <div class="border-t border-gray-100"></div>

            <!-- 简介内容 -->
            <div class="p-8 md:p-10">
                <h2 class="text-xl font-semibold text-gray-800 mb-4 flex items-center">
                    <i class="fa fa-user-o text-blue-500 mr-2"></i> 个人简介
                </h2>
                <p class="text-gray-600 mb-6 leading-relaxed">{{ profile.bio }}</p>

                <!-- 社交链接 -->
                <h2 class="text-xl font-semibold text-gray-800 mb-4 flex items-center">
                    <i class="fa fa-link text-blue-500 mr-2"></i> 联系方式
                </h2>
                <div class="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
                    <a
                        href="#"
                        class="flex items-center text-gray-600 hover:text-blue-600 transition-colors"
                        v-for="(social, index) in profile.social"
                        :key="index"
                    >
                        <i :class="['fa', social.icon, 'mr-2 text-lg']"></i>
                        <span>{{ social.label }}</span>
                    </a>
                </div>

                <!-- 修改按钮 -->
                <div class="text-center">
                    <button
                        @click="goToEditProfile"
                        class="bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-8 rounded-full transition-all duration-200 flex items-center justify-center mx-auto"
                    >
                        <i class="fa fa-pencil mr-2"></i> 修改个人简介
                    </button>
                </div>
            </div>
        </div>

        <!-- 空状态提示（无简介时） -->
        <div v-if="!profile.name" class="text-center p-6">
            <i class="fa fa-user-circle-o text-5xl text-gray-300 mb-4"></i>
            <h3 class="text-xl font-medium text-gray-700 mb-2">暂无个人简介</h3>
            <p class="text-gray-500 mb-6">点击"修改个人简介"按钮开始完善你的资料</p>
            <button
                @click="goToEditProfile"
                class="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-6 rounded-lg transition-colors duration-200"
            >
                <i class="fa fa-pencil mr-2"></i> 修改个人简介
            </button>
        </div>
    </div>
</template>

<script setup>
import {ref, onMounted, watch, onUnmounted} from 'vue';
import { useRouter } from 'vue-router';
const router = useRouter();
// 个人简介数据 (模拟数据)
const profile = ref({
    name: "张明",
    title: "前端开发工程师",
    avatar: "https://picsum.photos/200/200?random=101",
    bio: "专注于Vue.js和前端框架开发，有3年以上前端项目经验，熟悉Tailwind CSS、TypeScript等技术栈。热爱开源，喜欢分享技术心得。",
    location: "上海市",
    joinDate: "2021年5月",
    social: [
        { label: "GitHub", icon: "github" },
        { label: "博客", icon: "blog" },
        { label: "微博", icon: "weibo" },
        { label: "邮箱", icon: "envelope" }
    ]
})

// 跳转到编辑页面
const goToEditProfile = () => {
    console.log("跳转到个人简介编辑页面")
    // 实际项目中替换为路由跳转：router.push('/edit-profile')
}

// 模拟数据加载（实际项目中从API获取）
onMounted(() => {
    // 这里可以添加从服务器获取个人简介数据的逻辑
    // 示例：通过axios请求获取数据并更新profile
    console.log("个人简介数据已加载")
})
// 导航函数
const goBack = () => {
    router.go(-1)
}
</script>

<style>
/* 导入Font Awesome样式 */
.back{
    position: absolute;
    top: 20px;
    left: 40px;
}
</style>